import { PaginationBar } from 'mailup-web-components'
import React, { useRef } from 'react'
import { useIntl } from 'react-intl'
import { useRecoilCallback, useRecoilValue } from 'recoil'

import { useParams } from 'react-router-dom'
import { loadBounceTableCallback } from '../recoil/callbacks/callbacks'
import { tableStateResult, tableStateSerach } from '../recoil/state/result'

const Pagination = () => {
  const intl = useIntl()
  const { idRecipient } = useParams()
  const { pageNumber, pageSize } = useRecoilValue(tableStateSerach)
  const { totalItems } = useRecoilValue(tableStateResult)

  const loadBounceTable = useRecoilCallback(loadBounceTableCallback, [])

  const { current: handleChangePageNumber } = useRef((pageNumber) => {
    loadBounceTable({ idRecipient, pageNumber })
  })
  const { current: handleChangePageSize } = useRef((pageSize) => {
    loadBounceTable({ idRecipient, pageSize, pageNumber: 1 })
  })

  return (
    <PaginationBar
      pageNumber={pageNumber}
      pageSize={pageSize}
      totalItems={totalItems}
      strings={{
        of: intl.formatMessage({ id: 'Load.Pager.Of' }),
        label: intl.formatMessage({ id: 'Load.Pager.Items' }),
      }}
      handleChangePage={handleChangePageNumber}
      handleChangePageSize={handleChangePageSize}
      data-mu-test="pagination"
    />
  )
}

export default Pagination
